import { Action, Type } from "../actions/Custom/Custom.Actions";
import { ICustomTab } from "@vmosolutions/oc-interfaces";

export interface ICustomPagesState {
  flight: ICustomTab[];
  movementMessages: {
    departure: string;
    arrival: string;
  };
  groundEvent: {
    [eventType: string]: ICustomTab[];
  };
  aircraft?: string;
  airport?: string;
  customer?: string;
}

const initialState: ICustomPagesState = {
  flight: [],
  movementMessages: {
    departure: "",
    arrival: "",
  },
  groundEvent: {},
  aircraft: "",
  airport: "",
  customer: "",
};

export const CustomPagesReducer = (state: ICustomPagesState = initialState, action: Action): ICustomPagesState => {
  switch (action.type) {
    case Type.GOT_CUSTOM_SCHEMA:
      return { ...state, ...action.customSchema };
    default:
      return state;
  }
};
